/* import __COLOCATED_TEMPLATE__ from './target.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { action, set, computed } from '@ember/object';
import { Action, getEvent, Page, Target as EventTarget } from '@banking/ui/utils/folder-cdp-events';
import { Currency, Money } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
import { Validation } from '@banking/ui/utils/validation';
import formatMoney from '@banking/ui/utils/format-money';
let Target = (_dec = computed('userInfo.currencyCode'), _dec2 = computed('automationSubaccountState.maxTargetAmount', 'currency'), _class = class Target extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "errorMessage", void 0);
    _defineProperty(this, "canContinue", true);
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "dataApi", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "userInfo", _descriptor4, this);
    _initializerDefineProperty(this, "formatter", _descriptor5, this);
    _defineProperty(this, "continue", void 0);
    _defineProperty(this, "goBack", void 0);
    _defineProperty(this, "validation", void 0);
    _defineProperty(this, "showValidation", false);
  }
  didInsertElement() {
    super.didInsertElement();
    const {
      name,
      properties
    } = getEvent(Action.View, {
      page: Page.SetGoal
    });
    this.dataApi.track(name, properties);
  }
  get currency() {
    return Currency[this.userInfo.currencyCode];
  }
  get maxTarget() {
    return new Money.Builder().amount(this.automationSubaccountState.maxTargetAmount).currency(this.currency).build();
  }
  validate() {
    let validation = new Validation();
    if (this.automationSubaccountState?.targetAmount && this.automationSubaccountState.targetAmount.amount > this.automationSubaccountState.maxTargetAmount) {
      validation = new Validation(this.intl.t('banking.savings.automation.create.target.aboveTargetError', {
        maxTarget: formatMoney(this.maxTarget, this.formatter),
        htmlSafe: true
      }));
    }
    set(this, 'validation', validation);
  }
  setTarget(value) {
    set(this.automationSubaccountState, 'targetAmount', value);
    this.validate();
  }
  _continue() {
    const {
      name,
      properties
    } = getEvent(Action.Click, {
      page: Page.SetGoal,
      target: EventTarget.SetGoal
    });
    this.dataApi.track(name, properties);
    set(this, 'showValidation', true);
    this.validate();
    if (this.validation?.isValid) {
      this.continue();
    }
  }
  skip() {
    const {
      name,
      properties
    } = getEvent(Action.Click, {
      page: Page.SetGoal,
      target: EventTarget.Skip
    });
    this.dataApi.track(name, properties);
    set(this.automationSubaccountState, 'targetAmount', undefined);
    this.continue();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "currency", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "currency"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxTarget", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "maxTarget"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "validate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTarget", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTarget"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_continue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_continue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skip", [action], Object.getOwnPropertyDescriptor(_class.prototype, "skip"), _class.prototype), _class);
export { Target as default };